import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import RegisteredNodeList from './containers/RegisteredNodeList';
import RegisteredNodeEdit from './containers/RegisteredNodeEdit';
import RegisteredNodeView from './containers/RegisteredNodeView';
import { SYSTEM_CONFIGURATION_ROUTE, REGISTERED_NODES, SYSTEM } from '../../constants';

interface Props {
}

const RegisteredNodes: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${REGISTERED_NODES}`}>
        <RegisteredNodeList />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${REGISTERED_NODES}/edit`}>
        <RegisteredNodeEdit />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${REGISTERED_NODES}/view`}>
        <RegisteredNodeView />
      </Route>
    </Fragment>
  );
};

export default RegisteredNodes;
